import { defineMessages } from 'react-intl';

export default defineMessages({
  pending: {
    id: 'admin.order_management.pending',
    defaultMessage: 'Pending',
  },
  picked: {
    id: 'admin.order_management.picked',
    defaultMessage: 'Picked',
  },
  packed: {
    id: 'admin.order_management.packed',
    defaultMessage: 'Packed',
  },
});
